import { Text, Flex, Box } from '@chakra-ui/react';
import { getIn } from 'formik';
import _ from 'lodash';
import React, { useState } from 'react';

import { WipConfig } from '../../types';
import { StickyHeaderSection } from 'packages/common-frontend/components/StickyHeaderSection';
import { AddButton } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddButton';
import { AddPropertyModal } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddPropertyModal';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { CreditAgreementSectionAccordionTable } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/CreditAgreementSectionAccordionTable';

type SettlementMechanicsProps = {
  settlementMechanics: CreditAgreement.DomainEntity.SettlementMechanics;
  wipConfig?: WipConfig;
};
export const SettlementMechanics = ({
  settlementMechanics,
  wipConfig,
}: SettlementMechanicsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const basePropertyKey = 'settlementMechanics';

  if (
    !wipConfig?.isMutateAllowed(basePropertyKey) &&
    !_.compact(Object.values(settlementMechanics)).length
  ) {
    return null;
  }

  return (
    <Box mt="40px">
      <StickyHeaderSection labelText="Settlement Mechanics">
        <Flex alignItems="center" mb="2">
          <Text fontWeight="bold" fontSize="20px">
            Properties
          </Text>
          {wipConfig?.isMutateAllowed(basePropertyKey) && (
            <>
              <AddButton setIsOpen={setIsOpen} />
              <AddPropertyModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                wipConfig={wipConfig}
                basePropertyKey={basePropertyKey}
                propertyMap={getIn(
                  wipConfig.creditAgreementFullArtifactPropertyMap,
                  basePropertyKey,
                )}
              />
            </>
          )}
        </Flex>
        <CreditAgreementSectionAccordionTable
          properties={settlementMechanics}
          basePropertyKey={basePropertyKey}
          wipConfig={wipConfig}
        />
      </StickyHeaderSection>
    </Box>
  );
};
